/* eslint-disable prettier/prettier */
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import DynamicComponent from './Components/DynamicComponent';
import 'react-tooltip/dist/react-tooltip.css';


//PandoNexis: BEGIN IMPORT
//PandoNexis: END IMPORT

import './pandoNexis.events.js';
import './pandoNexis.functions.js';


const renderReact = (element, container, callback) => {
    window.__pn.registeredContainers.push(container);
    ReactDOM.render(element, container, callback);
};

window.__pn = {
    ...window.__pn,
    initNewBuyButton: (button) => {
        initNewBuyButton(button);
    },
    cache: {}, // for storing cache data for current request
};


export const bootstrapPNComponents = () => {


    const initNewBuyButton = (button, buyButtonComponent) => {
        const BuyButton = buyButtonComponent ? buyButtonComponent : DynamicComponent({
            loader: () => import('./_PandoNexis/Components/BuyButton'),
        });

        const {
            articleNumber,
            quantityFieldId,
            href,
            cssClass,
            label,
            gtmTrackingData,
        } = button.dataset;
        renderReact(
            <Provider store={window.__pn.store}>
                <BuyButton
                    {...{
                        label,
                        articleNumber,
                        quantityFieldId,
                        href,
                        cssClass,
                        gtmTrackingData,
                    }}
                />
            </Provider>,
            button
        );
    };
    
    const buyButtons = document.querySelectorAll('buy-button');
    if (buyButtons.length > 0) {
        const BuyButton = DynamicComponent({
            loader: () => import('./_PandoNexis/Components/BuyButton'), // import('./Components/BuyButton'),
        });
        Array.from(buyButtons).forEach(
            (button) => {
                initNewBuyButton(button, BuyButton);
            }
        );
    }

    // PRODUCT PAGE IMAGES
    const lightBoxImagesEl = document.getElementById('lightBoxImages');
    if (lightBoxImagesEl) {
        const LightboxImages = DynamicComponent({
            loader: () => import('./_Solution/Components/LightboxImages'),
        });
        import('./Reducers/LightboxImages.reducer').then(
            ({ lightboxImages }) => {
                window.__pn.store.injectReducer('lightboxImages', lightboxImages);
                const rootElement = lightBoxImagesEl;
                const images = Array.from(
                    rootElement.querySelectorAll('template')
                ).map((img) => ({
                    html: img.innerHTML,
                    src: img.dataset.src,
                }));
                renderReact(
                    <Provider store={window.__pn.store}>
                        <LightboxImages images={images} />
                    </Provider>,
                    lightBoxImagesEl
                );
            }
        );
    }
    // END PRODUCT PAGE IMAGES
    
    // ICONS
    const iconEls = document.querySelectorAll('.pn-icon');
    if (iconEls) {
        const PnIcon = DynamicComponent({
            loader: () => import('./_PandoNexis/Components/PnIcon'),
        });
        iconEls.forEach((elem) => {
            const { iconName, title, width, height } = elem.dataset;
            ReactDOM.render(
                <Provider store={window.__pn.store}>
                    <PnIcon iconName={iconName} title={title} width={width} height={height} />
                </Provider>,
                elem
            );
        });
    }
    
    // ADDONS
    
//PandoNexis: BEGIN  COMPONENT
    // CollectionPage
    const collectionPage = document.getElementById("collectionPage");
    if (collectionPage) {
        const CollectionPage = DynamicComponent({
            loader: () => import('./_Addons/PNCollectionPage/Components/CollectionPageContainer'),
        });

        const { collectionPageSystemId, link, linkText } = collectionPage.dataset;
        renderReact(
            <Provider store={window.__pn.store}>
                <CollectionPage {...{ collectionPageSystemId, link, linkText }} />
            </Provider>,
            collectionPage
        );
    }
    // END CollectionPage

    // Checkout page
    const checkoutEl = document.getElementById('checkout');
    if (checkoutEl) {
        const Checkout = DynamicComponent({
            loader: () => import('./_Addons/pnCheckoutExtended/Components/Checkout'),
        });
        renderReact(
            <Provider store={window.__pn.store}>
                <Checkout />
            </Provider>,
            checkoutEl
        );
    }
    // END Checkout page


//PandoNexis: END COMPONENT
}
